var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3;
import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser, enumParser, PartnerOrganizationBillingModel, PartnerOrganizationStatus, PartnerOrganizationTier, } from '#validation';
import { paginatedResponse } from '#web-service-api/common';
import { AccountOwnerSchema } from './account-owner.schema';
const BaseResellerDetailsSchema = z.object({
    id: z.string(),
    name: z.string(),
    status: enumParser(PartnerOrganizationStatus),
    tier: enumParser(PartnerOrganizationTier).nullable(),
    supportedBillingModels: z.array(enumParser(PartnerOrganizationBillingModel)),
    accountOwner: AccountOwnerSchema,
    createdAt: dateParser(),
    isDemo: z.boolean(),
});
const BaseClientDetailsSchema = z.object({
    id: z.string(),
    name: z.string(),
    status: enumParser(PartnerOrganizationStatus),
    notes: z.string().nullable(),
    supportedBillingModels: z.array(enumParser(PartnerOrganizationBillingModel)),
    createdAt: dateParser(),
    isDemo: z.boolean(),
});
export const MspResellerDetailsResponseSchema = BaseResellerDetailsSchema.extend({
    plan: z.string(),
    expirationDate: dateParser().nullable(),
    externalSubscriptionUrl: z.string().optional(),
    capabilities: z.object({
        storage: z.object({
            aws: z.object({
                current: z.number(),
                prepaid: z.number(),
                used: z.number(),
            }),
            custom: z.object({
                current: z.number(),
                prepaid: z.number(),
                used: z.number(),
            }),
            wasabi: z.object({
                current: z.number(),
                prepaid: z.number(),
                used: z.number(),
            }),
            ibm: z.object({
                current: z.number(),
                prepaid: z.number(),
                used: z.number(),
            }),
        }),
        nativeLayout: z.object({
            current: z.number(),
            prepaid: z.number(),
            used: z.number(),
        }),
        teamCache: z.object({
            installations: z.number(),
        }),
        clients: z.object({
            count: z.number(),
        }),
        workspaces: z.object({
            members: z.object({
                prepaid: z.number(),
                peak: z.number(),
            }),
        }),
    }),
    actions: z.object({
        canDelete: z.boolean(),
        canStartTrial: z.boolean(),
        canExtendTrial: z.boolean(),
        canStartContract: z.boolean(),
        canPreviewContract: z.boolean(),
        canUpdateContract: z.boolean(),
        canUpsell: z.boolean(),
        canSetupUpgrade: z.boolean(),
        canViewUpgradeSetup: z.boolean(),
        canMigrateContract: z.boolean(),
        canTransferWorkspaces: z.boolean(),
        canEditDemo: z.boolean(),
    }),
});
export class MspResellerDetailsResponseDto extends createZodDto(MspResellerDetailsResponseSchema) {
}
export const VarResellerDetailsResponseSchema = BaseResellerDetailsSchema.extend({
    capabilities: z.object({
        storage: z.object({
            aws: z.object({
                prepaid: z.number(),
            }),
            custom: z.object({
                prepaid: z.number(),
            }),
            wasabi: z.object({
                prepaid: z.number(),
            }),
            ibm: z.object({
                prepaid: z.number(),
            }),
        }),
        nativeLayout: z.object({
            prepaid: z.number(),
        }),
        teamCache: z.object({
            installations: z.number(),
        }),
        clients: z.object({
            count: z.number(),
        }),
    }),
    actions: z.object({
        canDelete: z.boolean(),
        canEditDemo: z.boolean(),
    }),
});
export class VarResellerDetailsResponseDto extends createZodDto(VarResellerDetailsResponseSchema) {
}
export const MspClientDetailsResponseSchema = BaseClientDetailsSchema.extend({
    notes: z.string().nullable(),
    capabilities: z.object({
        storage: z.object({
            aws: z.object({
                current: z.number(),
            }),
            custom: z.object({
                current: z.number(),
            }),
            wasabi: z.object({
                current: z.number(),
            }),
            ibm: z.object({
                current: z.number(),
            }),
        }),
        nativeLayout: z.object({
            current: z.number(),
        }),
        workspaces: z.object({
            members: z.object({
                current: z.number(),
            }),
        }),
    }),
    actions: z.object({
        canDelete: z.boolean(),
        canTransferWorkspaces: z.boolean(),
        canSetupUpgrade: z.boolean(),
        canUpdateUpgradeSetup: z.boolean(),
        canViewUpgradeSetup: z.boolean(),
    }),
});
export class MspClientDetailsResponseDto extends createZodDto(MspClientDetailsResponseSchema) {
}
export const VarClientDetailsResponseSchema = BaseClientDetailsSchema.extend({
    plan: z.string(),
    expirationDate: dateParser().nullable(),
    externalSubscriptionUrl: z.string().optional(),
    capabilities: z.object({
        storage: z.object({
            aws: z.object({
                current: z.number(),
                prepaid: z.number(),
                used: z.number(),
            }),
            custom: z.object({
                current: z.number(),
                prepaid: z.number(),
                used: z.number(),
            }),
            wasabi: z.object({
                current: z.number(),
                prepaid: z.number(),
                used: z.number(),
            }),
            ibm: z.object({
                current: z.number(),
                prepaid: z.number(),
                used: z.number(),
            }),
        }),
        teamCache: z.object({
            installations: z.number(),
        }),
        nativeLayout: z.object({
            current: z.number(),
            prepaid: z.number(),
            used: z.number(),
        }),
        workspaces: z.object({
            members: z.object({
                prepaid: z.number(),
                peak: z.number(),
            }),
        }),
    }),
    actions: z.object({
        canDelete: z.boolean(),
        canStartTrial: z.boolean(),
        canExtendTrial: z.boolean(),
        canStartContract: z.boolean(),
        canPreviewContract: z.boolean(),
        canUpdateContract: z.boolean(),
        canUpsell: z.boolean(),
        canSetupUpgrade: z.boolean(),
        canViewUpgradeSetup: z.boolean(),
        canMigrateContract: z.boolean(),
        canTransferWorkspaces: z.boolean(),
    }),
});
export class VarClientDetailsResponseDto extends createZodDto(VarClientDetailsResponseSchema) {
}
export const MspClientListItemSchema = z.object({
    id: z.string(),
    name: z.string(),
    status: enumParser(PartnerOrganizationStatus),
    supportedBillingModels: z.array(enumParser(PartnerOrganizationBillingModel)),
    parentOrganizationId: z.string(),
    isDemo: z.boolean(),
    capabilities: z.object({
        storage: z.object({
            aws: z.object({
                current: z.number(),
            }),
            custom: z.object({
                current: z.number(),
            }),
            wasabi: z.object({
                current: z.number(),
            }),
            ibm: z.object({
                current: z.number(),
            }),
        }),
        nativeLayout: z.object({
            current: z.number(),
        }),
        workspaces: z.object({
            count: z.number(),
            members: z.object({
                current: z.number(),
            }),
        }),
        filespaces: z.object({
            count: z.number(),
        }),
    }),
    /**
     * @deprecated Use `GET /partner-organizations/:id/actions` instead. Computing actions per row makes the list
     * query heavier with every action added. Removed once WebClient loads actions on demand.
     */
    actions: z.object({
        canDelete: z.boolean(),
        canTransferWorkspaces: z.boolean(),
        canSetupUpgrade: z.boolean(),
        canUpdateUpgradeSetup: z.boolean(),
        canViewUpgradeSetup: z.boolean(),
    }),
});
export const VarClientListItemSchema = z.object({
    id: z.string(),
    name: z.string(),
    status: enumParser(PartnerOrganizationStatus),
    supportedBillingModels: z.array(enumParser(PartnerOrganizationBillingModel)),
    parentOrganizationId: z.string(),
    isDemo: z.boolean(),
    expirationDate: dateParser().nullable(),
    externalSubscriptionUrl: z.string().optional(),
    capabilities: z.object({
        storage: z.object({
            aws: z.object({
                prepaid: z.number(),
                used: z.number(),
            }),
            custom: z.object({
                prepaid: z.number(),
                used: z.number(),
            }),
            wasabi: z.object({
                prepaid: z.number(),
                used: z.number(),
            }),
            ibm: z.object({
                prepaid: z.number(),
                used: z.number(),
            }),
        }),
        teamCache: z
            .object({
            installations: z.number(),
        })
            .optional(),
        nativeLayout: z
            .object({
            prepaid: z.number(),
            used: z.number(),
        })
            .optional(),
    }),
    /**
     * @deprecated Use `GET /partner-organizations/:id/actions` instead. Computing actions per row makes the list
     * query heavier with every action added. Removed once WebClient loads actions on demand.
     */
    actions: z.object({
        canDelete: z.boolean(),
        canStartTrial: z.boolean(),
        canExtendTrial: z.boolean(),
        canStartContract: z.boolean(),
        canPreviewContract: z.boolean(),
        canUpdateContract: z.boolean(),
        canUpsell: z.boolean(),
        canSetupUpgrade: z.boolean(),
        canViewUpgradeSetup: z.boolean(),
        canMigrateContract: z.boolean(),
        canTransferWorkspaces: z.boolean(),
    }),
});
export const MspClientListResponseSchema = paginatedResponse(MspClientListItemSchema);
_react_refresh_temp_1 = MspClientListResponseSchema;
$RefreshReg$(_react_refresh_temp_1, "MspClientListResponseSchema");
export class MspClientListResponseDto extends createZodDto(MspClientListResponseSchema) {
}
export const VarClientListResponseSchema = paginatedResponse(VarClientListItemSchema);
_react_refresh_temp_2 = VarClientListResponseSchema;
$RefreshReg$(_react_refresh_temp_2, "VarClientListResponseSchema");
export class VarClientListResponseDto extends createZodDto(VarClientListResponseSchema) {
}
export const ResellerListItemSchema = BaseResellerDetailsSchema.extend({
    capabilities: z.object({
        clients: z.object({
            count: z.number(),
        }),
    }),
    externalSubscriptionUrl: z.string().optional(),
    /**
     * @deprecated Use `GET /partner-organizations/:id/actions` instead. Computing actions per row makes the list
     * query heavier with every action added. Removed once WebClient loads actions on demand.
     */
    actions: z.object({
        canDelete: z.boolean().optional(),
        canStartTrial: z.boolean().optional(),
        canExtendTrial: z.boolean().optional(),
        canStartContract: z.boolean().optional(),
        canPreviewContract: z.boolean().optional(),
        canUpdateContract: z.boolean().optional(),
        canUpsell: z.boolean().optional(),
        canSetupUpgrade: z.boolean().optional(),
        canViewUpgradeSetup: z.boolean().optional(),
        canMigrateContract: z.boolean().optional(),
        canTransferWorkspaces: z.boolean().optional(),
    }),
});
export const ResellerListResponseSchema = paginatedResponse(ResellerListItemSchema);
_react_refresh_temp_3 = ResellerListResponseSchema;
$RefreshReg$(_react_refresh_temp_3, "ResellerListResponseSchema");
export class ResellerListResponseDto extends createZodDto(ResellerListResponseSchema) {
}
